<template>
  <div
    v-if="blocks && blocks.length"
    class="product-zone py-6 relative"
  >
    <div
      class="product-zone__background absolute top-0 bottom-0 block w-screen h-full pointer-events-none"
      :class="backgroundClass"
    />
    <div
      class="flex flex-col gap-10 px-5 lg:flex-row lg:gap-7 lg:px-0"
    >
      <ProductZoneBox
        v-for=" block in blocks"
        :key="block.header"
        :header="block.header"
        :header-class="block.headerTextColor"
        :link-text="block.linkText"
        :link-class="block.linkTextColor"
        :link-url="block.linkUrl"
        :product-filter="block.productFilter"
        class="flex-1 min-w-0"
      />
    </div>
  </div>
</template>

<script lang="ts">
import ProductZoneBox from '~/cms/ProductZone/ProductZoneBox.vue';
import type { ProductZoneBox as ProductZoneBoxType } from '~~/types/cms/ProductZoneBox';

export default defineComponent({
  name: 'ProductZone',
  components: {
    ProductZoneBox,
  },
  props: {
    blocks: {
      type: Array as PropType<ProductZoneBoxType[]>,
      default: () => {

        return [];
      
      },
    },
    backgroundClass: {
      type: String,
      default: 'bg-EXPONDO-grey-5',
    },
  },
});
</script>

<style scoped lang="scss">
.product-zone__background {
  left: calc(-50vw + 50%);
  z-index: -1;
}
</style>
